<script lang="ts" setup>
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { useAdminStore } from '@/modules/admin/store/adminStore'
import { ERouteNames } from '@/router/ERouteNames'

const router = useRouter()
const route = useRoute()
const adminStore = useAdminStore()
const { t } = useI18n()

const goBack = async () => {
  if (route.name === ERouteNames.ADMIN_NAV) {
    await router.push({ name: ERouteNames.HOME })
  } else await router.push({ name: ERouteNames.ADMIN_NAV })
}

const sectionTitle = computed(() => {
  const option = adminStore.adminOptions.find((opt) => opt.route === route.name)
  return option?.name ?? 'Админка'
})
</script>

<template>
  <div class="d-flex align-center w-100">
    <v-btn variant="text" size="x-small" prepend-icon="ri-arrow-left-line" @click.stop="goBack">
      {{ t('common.back') }}
    </v-btn>

    <div class="flex-grow-1 text-center">
      <span class="text-uppercase">
        {{ sectionTitle }}
      </span>
    </div>
  </div>
</template>
